var React = require('react');

function Checkbox14x14 (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"1","y":"1.5","width":"12","height":"12","rx":"2","stroke":"currentColor","strokeWidth":"2"}));
}

Checkbox14x14.defaultProps = {"width":"14","height":"15","viewBox":"0 0 14 15","fill":"none"};

module.exports = Checkbox14x14;

Checkbox14x14.default = Checkbox14x14;
